<template>
  <div class=machine-container>
    <strong
      class="red--text text--lighten-1"
      v-if="!valid"
    >
      Es muss mindestens eine Machine ausgewählt sein
    </strong>
    <div :class="getMachineElementDisplayClass(machine)" v-for="machine in fullMachineList" :key="machine.id">
      <v-checkbox
        readonly
        :label="machine.displayName"
        :input-value="isMachineSelected(machine)"
        v-on:click.stop="() => toggleMachine(machine)"
      />
    </div>
    <strong
      class="red--text text--lighten-1"
      v-if="!valid"
    >
      Es muss mindestens eine Machine ausgewählt sein
    </strong>
  </div>
</template>

<script>
export default {
  name: 'MachineUsageSelect',
  props: {
    selectedMachine: {
      type: String,
    },
    selectedTools: {
      type: Array,
      required: true,
    },
    hideInactive: {
      type: Boolean,
      default: false,
    }
  },
  computed: {
    fullMachineList() {
      const machinesAndTools = [];
      const toolsThatCanBeUsedWithAnyMachine = [];

      this.machines.forEach(m => {
        if (m.isToolThatCanBeUsedWithAnyMachine) {
          toolsThatCanBeUsedWithAnyMachine.push(m);
        } else {
          machinesAndTools.push({
            ...m,
            isTool: false,
            parentId: null,
          });
          m.tools.filter(x => !this.hideInactive || x.isActive).forEach(t => {
            machinesAndTools.push({
              ...t,
              isTool: true,
              parentId: m.id,
            });
          });
        }
      });

      return [
        ...machinesAndTools,
        ...toolsThatCanBeUsedWithAnyMachine,
      ];
    },
    valid() {
      if (this.selectedMachines.length <= 0) {
        return true;
      }

      const machineIndex = this.selectedMachines.findIndex(x => !x.parentId && !x.isToolThatCanBeUsedWithAnyMachine);

      // If we selected something, at least one machine must be selected
      // (we cannot select only tool that can be used with any machine alone)
      return machineIndex >= 0;
    },
    machines() {
      return this.$store.state.machines.filter(x => !this.hideInactive || x.isActive);
    },
  },
  methods: {
    createSelectionResult() {
      const machine = this.selectedMachines.find(x => !x.parentId && !x.isToolThatCanBeUsedWithAnyMachine);
      const result = {
        machine: machine ? machine.id : null,
        tools: this.selectedMachines.filter(x => !!x.parentId || x.isToolThatCanBeUsedWithAnyMachine).map(x => x.id),
      };

      return result;
    },
    createSelectedMachinesListFromIds(machineId, toolIds) {
      const result = [];

      if (machineId) {
        const machine = this.fullMachineList.find(m => m.id === machineId);
        result.push(machine);
      }

      result.push(...toolIds.map(x => this.fullMachineList.find(m => m.id === x)));

      return result;
    },
    isMachineSelected(m) {
      return this.selectedMachines.some(x => x.id === m.id);
    },
    toggleMachine(m) {
      const toggleIndex = this.selectedMachines.findIndex(x => x.id === m.id);
      const checked = toggleIndex < 0; // Was not checked before

      if (m.isToolThatCanBeUsedWithAnyMachine) {
        if (toggleIndex >= 0) {
          this.selectedMachines.splice(toggleIndex, 1);
        } else {
          this.selectedMachines.push(m);
        }
      } else if (checked) {
        this.unselectMachineUsagesInAllGroupsOtherThan(m);
        this.selectMeAndMyPotentialParent(m);
      } else {
        this.unselectMeAndMyPotentialChildren(m);
      }

      this.$emit('selectionChanged', this.createSelectionResult());
    },
    selectMeAndMyPotentialParent(m) {
      if (!m.parentId) {
        this.selectedMachines.push(m);
      } else {
        const parent = this.machines.find(x => x.id === m.parentId);
        this.selectedMachines.push(parent);
        this.selectedMachines.push(m);
      }
    },
    unselectMeAndMyPotentialChildren(m) {
      if (m.parentId) { // I am a tool
        const deleteIndex = this.selectedMachines.findIndex(x => x.id === m.id);
        if (deleteIndex >= 0) {
          this.selectedMachines.splice(deleteIndex, 1);
        }
      } else { // I am a machine, uncheck me and my children also
        const newSelection = [];

        this.selectedMachines.forEach(s => {
          if (s.id !== m.id && s.parentId !== m.id) {
            newSelection.push(s);
          }
        });

        this.selectedMachines = newSelection;
      }
    },
    unselectMachineUsagesInAllGroupsOtherThan(m) {
      const newSelection = [];

      if (m.parentId) { // I am a tool
        this.selectedMachines.forEach(s => {
          if (s.isToolThatCanBeUsedWithAnyMachine ||
            (s.parentId === m.parentId) || // include my siblings
            (s.id === m.id) // include my parent
          ) {
            newSelection.push(s);
          }
        });
      } else { // I am a machine
        this.selectedMachines.forEach(s => {
          if (s.isToolThatCanBeUsedWithAnyMachine ||
          (s.parentId === m.id) // Include my children
        ) {
            newSelection.push(s);
          }
        });
      }

      this.selectedMachines = newSelection;
    },
    getMachineElementDisplayClass(m) {
      if (!m.isTool) {
        return 'machine-item';
      }

      return 'machine-item machine-item-indent';
    },
  },
  data:() => ({
    selectedMachines: [],
  }),
  mounted() {
    this.selectedMachines = this.createSelectedMachinesListFromIds(this.selectedMachine, this.selectedTools);
  },
};
</script>

<style>
  .machine-container {
    height: 600px;
    max-height: 600px;
    overflow-y: scroll
  }
  .machine-item {
    border-bottom: 1px solid #f3f3f3;
  }
  .machine-item-indent {
    padding-left: 60px;
  }
</style>
